import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@contexts/AuthContext";
import { getTokens } from "@utils/authStorage";
import { css } from "@emotion/css";
import { HEADER_HEIGHT } from "@components/Header";
import { Flex } from "@components/Flex";
import { Loader } from "./Loader";

/**
 * Route component that only allows access to users with wand.tech email addresses
 */
const WandTechRoute: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();
  const { userData } = getTokens();

  if (loading) {
    return (
      <Flex
        direction="column"
        align="center"
        justify="center"
        className={loadingStyle}
      >
        <Loader />
      </Flex>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // Check if user has a wand.tech email
  const hasWandTechEmail = userData?.email?.endsWith('@wand.tech');
  
  if (!hasWandTechEmail) {
    return <Navigate to="/color" />;
  }

  return <Outlet />;
};

const loadingStyle = css`
  min-height: calc(100vh - ${HEADER_HEIGHT}px);
`;

export default WandTechRoute;